class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.featured-carousel__track');
    this.prevBtn = this.querySelector('.featured-carousel__arrow--prev');
    this.nextBtn = this.querySelector('.featured-carousel__arrow--next');

    if (!this.track || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    this.track.addEventListener('scroll', () => this.updateArrowState());
    window.addEventListener('resize', () => this.updateArrowState());

    this.updateArrowState();
  }

  scrollByCard(direction) {
    const card = this.track.querySelector('.featured-carousel__item');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width;
    const gap = 16;
    this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  updateArrowState() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.prevBtn.disabled = scrollLeft <= 4;
    this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 4;
  }
}

customElements.define('product-carousel', ProductCarousel);